import { Layout } from "antd";
import Header from "./Header/index";
import AppRoutes from "./AppRoutes";
const { Content } = Layout;

export default function Index() {
  return (
    <div>
      <Layout>
        <Header />
        <Content
          className="site-layout"
          style={{ padding: "0 50px", marginTop: 64, background: "white" }}
        >
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 380 }}
          >
            <AppRoutes />
          </div>
        </Content>
      </Layout>
    </div>
  );
}
